import AttendanceSerializer from './base';

export default class Intervention extends AttendanceSerializer {}
